import { Component, Input, OnInit } from '@angular/core';
import { Yii } from "../../../../interfaces/Yii";
import { CarModel } from "../../../../models/car/car.model";
import { makeModel } from "../../../../service/utils/utils.service";
import { PriceType } from "../../../price/price.component";
import { LanguageService } from "../../../../service/language/language.service";

class WordingClass {
    public readonly title: string = Yii.t('wui-shared-js', 'Étapes');
    public readonly details: string = Yii.t('wui-shared-js', 'Détails');
    public readonly noHost: string = Yii.t('wui-shared-js', 'Pas de host');
    public readonly noPrice: string = Yii.t('wui-shared-js', 'Pas de prix');
    public readonly noVehicleRentalBookingModel: string = Yii.t('wui-shared-js', 'Le dossier n\'est pas valide');
}

@Component({
    selector: 'vehicle-rental-step',
    template: `
        <card #cardContainer [isCollapsible]="true">
            <div class="card-header-content">
                <div class="title">
                    {{ wording.title }}
                </div>
            </div>
            <div class="card-body-content content">
                <aside>
                    <car-title *ngIf="vehicleRentalBookingModel else noVehicleRentalBookingModel"
                               [booking]="vehicleRentalBookingModel"></car-title>
                </aside>
                <section>
                    <div *ngIf="vehicleRentalBookingModel else noVehicleRentalBookingModel">
                        <pick-car-informations [booking]="vehicleRentalBookingModel"
                                               [locale]="locale"></pick-car-informations>
                        <pick-car-informations [booking]="vehicleRentalBookingModel" [type]="'dropOff'"
                                               [locale]="locale"></pick-car-informations>
                        <btn type="actionDo" [label]="wording.details" (click)="isDisplayModalDetails=true;"></btn>
                    </div>
                    <ng-template #noVehicleRentalBookingModel>
                        <h4>{{wording.noVehicleRentalBookingModel}}</h4>
                    </ng-template>
                    <h3 *ngIf="host else noHost">{{host}}</h3>
                    <ng-template #noHost>
                        <h4>{{wording.noHost}}</h4>
                    </ng-template>
                    <price *ngIf="price else noPrice" [type]="big" [value]="price.value"
                           [currency]="price.currency"></price>
                    <ng-template #noPrice>
                        <h4>{{wording.noPrice}}</h4>
                    </ng-template>
                </section>
            </div>
        </card>
        <block-car-modal-contact *ngIf="vehicleRentalBookingModel"
                                 [booking]="vehicleRentalBookingModel"
                                 [showModal]="isDisplayModalDetails"
                                 (showModalEventEmit)="isDisplayModalDetails=false"></block-car-modal-contact>
    `,
    styleUrls: ['../card.scss'],
    styles: [`
        .content {
            display: grid;
            grid-template-columns: 225px 1fr;
        }

        .content > * {
            padding: 0.75rem;
        }

        .content aside {
            background-color: #fefefe;
            border-bottom: 1px solid rgba(189, 195, 199, 0.2);
            border-right: 1px solid rgba(189, 195, 199, 0.2);
            justify-self: center;
            width: 100%;
        }

        .content section {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr;
            background-color: #f9fafc;
        }
        pick-car-informations {
            margin-bottom: .75rem;
        }
    `]
})
export class VehicleRentalStepComponent implements OnInit {
    @Input()
    public bookingExtraData: any = null;

    public locale: string = 'fr';
    public vehicleRentalBookingModel: CarModel = null;
    public readonly wording: WordingClass = new WordingClass();
    public host: string = null;
    public price: any = null;
    public big: PriceType = PriceType.big;
    public isDisplayModalDetails: boolean = false;

    constructor(
        private languageService: LanguageService,
    ) {
        this.locale = this.languageService.getUserLanguage();
    }

    public ngOnInit(): void {
        this.initVehicleRentalBookingModel();
        if (this.vehicleRentalBookingModel) {
            this.initHost();
            this.initPriceValue();
        }
    }

    private initVehicleRentalBookingModel(): void {
        this.vehicleRentalBookingModel = makeModel(this.bookingExtraData, CarModel);
    }

    private initHost(): void {
        this.host = this.vehicleRentalBookingModel.booking.host.code;
    }

    private initPriceValue(): void {
        this.price = this.vehicleRentalBookingModel.booking.total.sumTotalWithoutXReason;
    }

}
